/**************************************************************************************************************************************************
*   MODULE NAME     :  Auth
*   AUTHOR          :  GLSD DEV Team
*   DATE            :  29-Jan-2025
*   DESCRIPTION     :  Gateway parameters
*   Copyright 2025 Eli Lilly and Company
*   All rights reserved
*
/**************************************************************************************************************************************************
*   *** CHANGE HISTORY ***
/**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG2467262
*   DESCRIPTION: <GLSD>: Node 20 Upgrade and Implement MSAL
*   DATE: 29-Jan-2025
/**************************************************************************************************************************************************/

const GATEWAY_SCOPES = {
  NON_PRODUCTION_GATEWAY_SCOPE: 'api://39b64b04-e385-4232-a4e2-604367e2d849/.default',
  PRODUCTION_GATEWAY_SCOPE: 'api://39b64b04-e385-4232-a4e2-604367e2d849/.default',
};

const GATEWAY_SCOPES_TYPES = {
  PRODUCTION: 'production',
  NON_PRODUCTION: 'non_production',
};

Object.freeze(GATEWAY_SCOPES);
Object.freeze(GATEWAY_SCOPES_TYPES);
export { GATEWAY_SCOPES, GATEWAY_SCOPES_TYPES };
